import React from 'react';
import SimpleCrud from '../components/SimpleCrud';

export default function Shuls() {
  return <SimpleCrud title="Shuls" basePath="shuls" fields={[
    { key: 'name', label: 'Shul name' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
  ]} />;
}
